import { render, staticRenderFns } from "./CollectionForm.vue?vue&type=template&id=2f4aece7"
import script from "./CollectionForm.vue?vue&type=script&lang=js"
export * from "./CollectionForm.vue?vue&type=script&lang=js"
import style0 from "./CollectionForm.vue?vue&type=style&index=0&id=2f4aece7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports